export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20composition%20with%20soft%20flowing%20silk%20fabric%20textures%20in%20rose%20gold%20and%20cream%20tones%2C%20gentle%20morning%20light%20filtering%20through%2C%20delicate%20floral%20petals%20scattered%20elegantly%2C%20dreamy%20atmospheric%20scene%2C%20emotional%20and%20sophisticated%20mood%2C%20fine%20art%20luxury%20photography&width=1800&height=800&seq=about-hero-01&orientation=landscape"
        alt="久久伊人 - 品牌故事"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <span className="inline-block text-xs font-medium tracking-widest uppercase text-accent-300 bg-accent-500/20 px-4 py-1.5 rounded-full mb-5">
          ABOUT US
        </span>
        <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 tracking-wide">
          关于久久伊人
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto leading-relaxed">
          以真诚与用心守护每一段珍贵关系，让美好情感久久延续
        </p>
      </div>
    </section>
  );
}